
export default {
  props: {
    post: {
      type: Object,
      default: null
    }
  }
}
